<template>
    <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Edit Trade</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6 required">
                            <label for="inputEmail4">Price</label>
                            <input  type="text" class="form-control" id="inputEmail4" placeholder="Price" v-model="tradeData.price"  >
                        </div>
                        <div class="form-group col-md-6">
                            <label for="inputLast">CommConcAmount </label> 
                            <input type="text" class="form-control" id="inputLast" placeholder="CommConcAmount" v-model="tradeData.commConcAmount " >
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 ">
                            <label for="inputLast">ExecBrokerMinor </label>
                            <input type="text" class="form-control" id="inputLast" placeholder="Exec Broker Minor" v-model="tradeData.execBrokerMinor "> 
                        </div>
                        <div class="form-group col-md-6">
                            <label for="inputEmail4">Transaction Type</label>
                            <div style="margin: 8px;font-size: 14px;color: #000;">{{tradeData.transactionType ? tradeData.transactionType.toString(): "N/A"}}</div>
                            <!-- <select v-model="tradeData.transactionType" class="form-control">
                                <option value="Trade Profit">Trade Profit</option>
                                <option value="Sales Credit">Sales Credit</option>
                                <option value="RS Commissions">RS Commissions</option>
                                <option value="JP Commissions">JP Commissions</option>
                                <option value="Off-Board Transactions">Off-Board Transactions</option>
                            </select> -->
                        </div>   
                        <div class="form-group col-md-6" v-if="tradeData.transactionType && commissions.some(r=> tradeData.transactionType.indexOf(r) >= 0)">
                            <label for="inputEmail4">Change Transaction Type</label>
                            <select v-model="transactionTypeUpdate" class="form-control">
                                <option v-for="commission in commissions" :key="commission" >{{commission}}</option>
                                
                            </select>
                        </div> 
                    </div>
                    
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <p v-if="errors.length">
                        <ul>
                        <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                        </ul>
                    </p>
                    <div class="modal-footer bid">
                        <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                        <button :disabled="disableEdit" type="button" class="btn btn-primary" @click="updateTrade()">UPDATE TRADE</button>
                    </div>
              </form>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
    name: 'pltraderadd',
    components :{
        
    },
    props: ['tradeData'],
    data() {
        return {
            loading : false,
            errors: [],
            commissions : [],
            transactionTypeUpdate : null,
            disableEdit : false           

        };
    },
    methods: {   
        getCommissions(){
            this.repLoading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
            config.baseUrlBidSide +
                "/pnl/commissions",
                auth
            )
            .then(result => {
                this.commissions = result.data.map((data) => {return data.commissionName});
                let self = this
                this.commissions.forEach((data) =>{
                    if(self.tradeData.transactionType.includes(data)){
                        self.transactionTypeUpdate = data
                    }
                })
            })        
        },
        updateTrade(){
            
            let tradeId = null;
            let tradeType = null;
            if(this.tradeData.id) {
                tradeId = this.tradeData.id;
                tradeType = this.tradeData.type;
            }    
            if(this.tradeData.buyId){
                tradeId = this.tradeData.buyId;
                tradeType = 'BUY';

            }
            if(this.tradeData.sellId) {
                tradeId = this.tradeData.sellId;
                tradeType = 'SELL';

            }
            if(!this.tradeData.price){
                this.$alert("Price is required.","","error");
                return false
            }
            let transactionType = this.tradeData.transactionType ? this.tradeData.transactionType : [];
            let self = this;
            if(this.tradeData.transactionType && this.commissions.some(r=> this.tradeData.transactionType.indexOf(r) >= 0)){
                //this.tradeData.transactionType,
                transactionType = this.tradeData.transactionType.filter(function(e) { return !self.commissions.includes(e)})
                transactionType.push(this.transactionTypeUpdate);
            }

            var addData = { 
                tradeId: tradeId,
                type : tradeType,
                price :this.tradeData.price,
                commConcAmount :this.tradeData.commConcAmount,
                execBrokerMinor :this.tradeData.execBrokerMinor,
                transactionType : transactionType,
                cognitoSub : authService.getUser().cognitoSub
            };
            console.log(addData)
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.loading = true;
            this.$http
            .post(config.baseUrlBidSide + "/pnl/trade-update", addData, auth)
            .then(() => {
                this.loading = false;              
                this.$emit('close');               
            })
            .catch(() => {
                this.loading = false;              
            });
        }
        

    },
    mounted(){
        this.getPLRemapStatus().then((result) => {
            if(result.data.remapOngoing){
                this.$alert(this.appMessages.plRemapMessage,"","warning");  
                this.disableEdit = true;            
            }else{
                this.disableEdit = false;            
                
            }
        })
        this.getCommissions();
    }
    };
</script>